@if (category()) {
  <cx-generic-link class="subcategory" [url]="category().url"
                   [attr.data-test]="'subcategories--item' + category().id + '-link'">
    <div class="subcategory--content" [attr.data-test]="'subcategories--item' + category().id + '-content'">
      <cx-media  [attr.data-test]="'subcategories--item' + category().id + '-media'"
        class="image" [container]="category().image" loading="lazy"
      ></cx-media>
      <div class="subcategory--title"
           [attr.data-test]="'subcategories--item' + category().id + '-title'">{{ category().name }}
        <mat-icon class="arrow" svgIcon="arrow-right"></mat-icon>
      </div>
    </div>
  </cx-generic-link>
}
